export default "/images/vendor/flag-icon-css/flags/4x3/pe.svg?9e2ec84ad461c170e9e5ece9be584c46";